// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__NAura","title":"ClientReferral_title__Lr0i7","itemText":"ClientReferral_itemText__3qJUy"};